import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  OnChanges,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';
import { NotificationErrorService } from 'src/app/modules/acbcr/common/services/notification-error.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';

@Component({
  selector: 'app-pedigree-form-block',
  templateUrl: './pedigree-form-block.component.html',
})
export class PedigreeFormBlockComponent implements OnInit, OnChanges, OnDestroy {
  @Input() animalForm: UntypedFormGroup;
  @Input() disabledFields = {};
  @Input() updateFields = new Subject();

  destroy$: Subject<boolean> = new Subject<boolean>();
  animalFamilyTree;
  addEditModalData;
  matricol: string;

  loadingDescarcaXLS = false;
  loadingChart = false;

  constructor(
    private animalsTableService: AnimalsTableService,
    private helperDataService: HelperDataService,
    private errorService: NotificationErrorService
  ) {
    this.animalFamilyTree = [];
  }

  ngOnInit(): void {
    this.matricol = this.animalForm.value.numarmatricol;

    this.updateFields.subscribe((response) => {
      if (this.animalFamilyTree && this.animalFamilyTree[0]) {
        this.animalFamilyTree[0].numarmatricol = this.animalForm.value.numarmatricol;
        this.animalFamilyTree[0].datanastere = this.animalForm.value.datanastere;
        this.animalFamilyTree[0].rasa = '';
      }
    })
  }

  ngOnChanges(changes) {
    if (changes.animalForm && this.animalForm) {
      this.getData();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  getData() {
    this.loadingChart = true;
    this.animalFamilyTree = [];
    let req_params = {
      animal_id: this.animalForm.value.id,
      tata_id: this.animalForm.value.tataid,
      mama_id: this.animalForm.value.mamaid,
    };

    this.animalsTableService.arboreGenealogicGenereazaAPI(req_params)
      .subscribe(response => {
        this.loadingChart = false;

        if (!response) {
          return;
        }

        this.animalFamilyTree = [ response ];

        if (! this.animalFamilyTree[0].numarmatricol) {
          this.animalFamilyTree[0].numarmatricol = this.animalForm.value.numarmatricol;
        }
      });
  }

  get f() {
    return this.animalForm.controls;
  }

  rasaVal(event?, index?) {
    let sum = 0;
    this.animalForm.controls.rase.value.forEach(
      (rasa) => sum += parseInt(rasa.val, 10)
    );

    if (sum > 100) {
      this.errorService.processErrorMsg('procent rasa mai mare decat 100');
    }
  }

  deleteParent(node) {
    if (node.ascendenta === 'T') {
      this.animalForm.controls.tataid.reset();
    } else if (node.ascendenta === 'M') {
      this.animalForm.controls.mamaid.reset();
    }

    this.getData();
  }

  onNodeSelect(event) {
    let ascendenta = event?.node?.ascendenta;

    if (! ['T', 'M'].includes(ascendenta)) {
      return;
    }

    let ascendentaNode = ascendenta + (this.animalForm.value.ascendenta || '');

    if (event.node.numarmatricol.includes('mamă')) {
      this.addEditModalData = {
        animalData: null,
        modalType: 'add-mother',
        matricolChild: this.animalForm.value.numarmatricol,
        ascendenta: ascendentaNode,
      };
    } else if (event.node.numarmatricol.includes('tată')) {
      this.addEditModalData = {
        animalData: null,
        modalType: 'add-father',
        matricolChild: this.animalForm.value.numarmatricol,
        ascendenta: ascendentaNode,
      };
    }
  }

  closeAddUpdateModal(event) {
    if (!event) {
      return;
    }

    if (String(event.sex) === '1') {
      this.animalForm.controls.tataid.setValue(event.id);
    } else if (String(event.sex) === '2') {
      this.animalForm.controls.mamaid.setValue(event.id);
    }

    if (this.animalForm.value.tataid && this.animalForm.value.mamaid) {
      let raseFormArray = this.animalForm.controls.rase as UntypedFormArray;
      raseFormArray.clear()
    }

    this.getData();
  }

  downloadXLSArboreGenealogic() {
    this.loadingDescarcaXLS = true;
    let matricol = this.animalForm.value.numarmatricol;
    let fisier = `arbore_genealogic_${matricol}.xls`;

    let req_params = {
      animal_id: this.animalForm.value.id,
    };

    this.animalsTableService.downloadXLSArboreGenealogicAPI(req_params)
      .subscribe({
        next: (response: any) => {
          this.loadingDescarcaXLS = false;
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);
        }
      });
  }

}
